<div>
  @if (form) {
    <form [formGroup]="form">
      @for (field of formFields$ | async; track field) {
        <div class="form-row">
          <emm-dynamic-menu-form-field
            [formField]="field" [form]="form" [item]="item" [itemTag]="itemTag"
            [selectedSubmenu]="selectedSubmenu"
            [selectedLocation]="selectedLocation"
            [nodeId]="nodeId" [itemTagPath]="this.itemTagPath"
            [selectedFeatureScope]="selectedFeatureScope"
            [effectiveDate]="effectiveDate"
            [selectedLanguage]="language"
            [isCascade]="isCascade"
            (removeLocalAttribute)="handleRemoveLocalAttribute($event)"
          ></emm-dynamic-menu-form-field>
        </div>
      }
    </form>
  }
</div>
